import GhostGuard from "middleware/GhostGuard";

const ghostRoutes = {
  id: "ghost",
  children: [
 
    {
      path: "email-verification",
      lazy: async () => ({
        Component: (await import("app/pages/Auth/EmailVerificationSuccess")).default,
      }),
    },
    {
      Component: GhostGuard,
      children: [
        {
          path: "login",
          lazy: async () => ({
            Component: (await import("app/pages/Auth/Login")).default,
          }),
        },
        {
          path: "auth/forgot-password",
          lazy: async () => ({
            Component: (await import("app/pages/Auth/ForgotPassword")).default,
          }),
        },
        {
          path: "auth/otp-verification",
          lazy: async () => ({
            Component: (await import("app/pages/Auth/OtpVerification")).default,
          }),
        },
        {
          path: "auth/setup-password",
          lazy: async () => ({
            Component: (await import("app/pages/Auth/SetupPassword")).default,
          }),
        },
      ],
    },
  ],
};

export { ghostRoutes };
